export default __webpack_public_path__ + "img/fgKAyqtr.b20ee6a4.svg";